import * as React from "react";
import type { SVGProps } from "react";
const SvgHouseWithHeart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3 22h6a1 1 0 0 0 1-1v-5h1a1 1 0 0 0 0-2H9a1 1 0 0 0-1 1v5H4V9.5l7-5.25 7 5.25V12a1 1 0 0 0 2 0V9a1 1 0 0 0-.4-.8l-8-6a1 1 0 0 0-1.2 0l-8 6A1 1 0 0 0 2 9v12a1 1 0 0 0 1 1"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.8 21.71a1 1 0 0 0 .7.29 1 1 0 0 0 .75-.32l2.87-2.85a2.94 2.94 0 0 0-3.61-4.6 2.94 2.94 0 0 0-3.62 4.6zm.7-2.12-2.21-2.19v-.04A.945.945 0 0 1 16.6 16l.07.19a1 1 0 0 0 1.6 0 .94.94 0 0 1 1.32-.18.88.88 0 0 1 .37.62.9.9 0 0 1-.19.7.13.13 0 0 1-.06.07z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgHouseWithHeart;
